export const LanguageCodes = {
  FRENCH: { short: 'fr', long: 'fr-FR' },
  ENGLISH: { short: 'en', long: 'en-US' },
};
